import moment from "moment";
import axios from "../helper/axios";

  export function GetProductPlans(product,callback) {
    return async (Dispatch) => {
      var timestamp = moment("1976 01 27").unix();
      axios
        .get(`/getproductPlanInfo/${timestamp}/${product}`)  
        .then((res) => {
          localStorage.setItem("productPlans",JSON.stringify(res.data.data))
          Dispatch({ type: "Plans", payload: res.data });
          //console.log(localStorage)
          callback()
        })
        .catch((e) => console.log(e));
    };
  }